import '../../assets/resources/custom/style/main-6.css'
import '../../assets/resources/custom/style/bootstrap_hc.css'
import { Link } from "react-router-dom";
import image_person from '../../assets/resources/custom/icons/person.png'
import image_facebook from '../../assets/resources/custom/images/facebook.png'
import image_youtube from '../../assets/resources/custom/images/youtube.png'
import image_magnifying_glass from '../../assets/resources/custom/images/magnifying_glass.png'
import GetStrLocalized from '../../datas/GetStrLocalized'
import React, { useEffect, useState } from 'react'
import { HcContext, SizeOfWindow } from '../../types/hccontext';
import { gapi } from 'gapi-script';
import LoginModal from '../modal/LoginModal';
import MainSearchInputCentred from './MainSearchInputCentred';


interface BannerProps {
	language: string;
	hcContext: HcContext;
	canDisplaySearchBar: boolean;
	searchValue: string;
	minimum_height_to_scroll: number;
}

const Banner: React.FC<BannerProps> = ({ language, hcContext, canDisplaySearchBar, searchValue, minimum_height_to_scroll }) => {

	const [showLoginModal, setShowLoginModal] = useState(false);
	const [isScrolled, setIsScrolled] = useState(minimum_height_to_scroll === 0);

	useEffect(() => {
		// Usefull for google login
		function start() {
			gapi.auth2.init({
				clientId: process.env.REACT_PUBLIC_GOOGLE_CLIENT_ID,
				scope: 'email',
			});
		}
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			// Set state based on scroll position
			setIsScrolled(window.scrollY >= minimum_height_to_scroll);
		};

		// Add event listener
		window.addEventListener('scroll', handleScroll);

		// Clean up event listener on component unmount
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []); // Empty dependency array means this runs only once on mount

	return (
		<>
			<div style={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100%',
				height: '70px', // Matches your spacer div height
				backgroundColor: isScrolled ? hcContext.getBackgroundColor() : 'transparent',
				zIndex: 9, // Sits BEHIND your logo (30) and button (25)
				transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
			}} />
			<div style={{
				position: 'fixed',
				top: 0,
				left: '0px',
				width: '100%',
				height: '80px',
				zIndex: 10,
				transition: 'left 0.3s ease-out, width 0.3s ease-out',
			}}>
				<span style={{ display: 'block', height: 13 }}></span>
				<table style={{ width: '100%', height: '100%' }}>
					<thead className="visually-hidden"><tr><th></th></tr></thead>
					<tbody>
						<tr>
							<td style={{ width: 60 }}>
							</td>
							<td className="hc-top-bar-sides-css">
							</td>
							<td width="100%" className="hc-very-short-screen">
							</td>

							<td className="hc-not-very-short-screen">
								<span hidden={!canDisplaySearchBar || !isScrolled}>
									<MainSearchInputCentred language={language} searchValue={searchValue} hcContext={hcContext} />
								</span>
							</td>

							<td style={{ paddingTop: 5 }} className="hc-top-bar-sides-css">
								<table>
									<tbody>
										<tr>
											<td>
												{
													(hcContext.sizeOfWindow === SizeOfWindow.VERY_SHORT || !isScrolled) &&
													<span title="Options">
														<div style={{ paddingRight: 15 }}>
															<Link to={"/" + language + "/" + GetStrLocalized(language, "searchFolderName")}>
																<img src={image_magnifying_glass} alt="search" height="30px" width="30px" />
															</Link>
														</div>
													</span>
												}</td>

											{
												hcContext.sizeOfWindow >= SizeOfWindow.WIDE &&
												<>
													<td><span className="hc-not-very-short-screen" title={GetStrLocalized(language, "facebookPage")}>
														<span style={{ paddingRight: 15 }}>
															<a href="https://www.facebook.com/profile.php?id=100087443046272">
																<img src={image_facebook} alt="Facebook logo" height="30" width="30" />
															</a>
														</span>
													</span></td>

													<td><span className="hc-not-very-short-screen" title={GetStrLocalized(language, "youtubeChannel")}>
														<span style={{ paddingRight: 15 }}>
															<a href="https://www.youtube.com/c/HOLYChatterfr">
																<img src={image_youtube} alt="YouTube logo" height="30" width="30" />
															</a>
														</span>
													</span></td>
												</>
											}

											<td>
												<span className="hc-not-very-short-screen" title="API">
													<div style={{ marginTop: 7, paddingRight: 15 }}>
														<Link to={"/" + language + "/" + GetStrLocalized(language, "apiFolderName")} className="hc-api" title={GetStrLocalized(language, "accessTheApi")}>API</Link>
													</div>
												</span>
											</td>

											<td>
												<span title="Google authentification">
													<div style={{ paddingRight: 15 }}>
														{
															hcContext.userIsIdentified &&
																hcContext.user ?
																<img src={hcContext.user.picture} onClick={() => hcContext.clearUser()} alt="disconnect" className='hc-cursor-pointer' height="30" width="30" style={{ borderRadius: '50%' }} />
																:
																<img src={image_person} referrerPolicy='no-referrer' onClick={() => setShowLoginModal(true)} alt="sign in" className='hc-cursor-pointer' height="30" width="30" style={{ borderRadius: '50%' }} />
														}

														{
															showLoginModal &&
															<LoginModal
																language={language}
																setShow={setShowLoginModal}
																hcContext={hcContext}
															/>
														}
													</div>
												</span>
											</td>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

		</>
	)

}

export default Banner
